import type { ProductFragment } from '@/lib/types/datocms/graphql/generated'
import ProductSection from './ProductSection'
import { renderRule, StructuredText } from 'react-datocms'
import { isStructuredTextEmpty } from '@/utils/datocms/isStructuredTextEmpty'
import CtaLarge from '../ui/cta/CtaLarge'
import { isHeading } from 'datocms-structured-text-utils'
import type { ReactNode } from 'react'
import type { ProductPageSections } from '@/utils/datocms/sectionTypes'

type Props = {
	overview: ProductFragment['overview']
	description?: ProductFragment['productDescription']
	isProductPage?: boolean
	cta?: ProductFragment['cta']
	inMegaMenu?: boolean
}

export function Overview({
	overview,
	description,
	isProductPage,
	cta,
	inMegaMenu,
}: Readonly<Props>) {
	const headingRender = (children: ReactNode, node: any) => {
		const id = node.children?.map((child: any) => child.value).join('')
		const Tag: any = `h${node.level}`

		const className = node.level === 2 ? 'text-2xl @3xl:text-3xl @4xl:heading-size-4 max-w-3xl' : ''

		return (
			<Tag key={id} id={id} className={className}>
				{children}
			</Tag>
		)
	}
	return (
		<section className="overview-slices @container">
			{description && (
				<div className="flex flex-col @2xl:flex-row justify-between common-x-padding max-w-screen-2xl mx-auto py-3 @4xl:py-16 @7xl:py-24 gap-10 @2xl:gap-20">
					{/* Large Product Description */}
					{isProductPage && !isStructuredTextEmpty(description) && (
						<StructuredText
							data={description}
							customNodeRules={[
								renderRule(isHeading, ({ children, node }) => headingRender(children, node)),
							]}
						/>
					)}

					{cta && (
						<CtaLarge
							cta={cta}
							icon={{ icon: 'Bolt', orientation: 'left' }}
							className="@3xl:w-[305px] shrink-0"
						/>
					)}
				</div>
			)}

			{overview.map((section: ProductPageSections) => (
				<ProductSection key={section.id as string} section={section} inMegaMenu={inMegaMenu} />
			))}
		</section>
	)
}
